module.exports = __webpack_public_path__ + "../static/img/ap.06b3c0d0.png";